// import React, { useState } from 'react';
// import { Container, Row, Col, Form, Button, Card, InputGroup, Badge, Spinner } from 'react-bootstrap';
// import { FaUser, FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
// import { MdOutlineStickyNote2, MdSavings } from 'react-icons/md';
// import { motion } from 'framer-motion';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../../../store/AuthContext';
// import { ApiPath } from '../../../../config';

// const SubscriptionForm = () => {
//   // TJP Brand Colors
//   const colors = {
//     primaryOrange: '#FD7E4B',
//     primaryGreen: '#2e7d32',
//     creamBg: '#FDF0DD',
//     lightCream: '#FFFBF2'
//   };

//   // --- 1. STATE MANAGEMENT ---
//   const navigate = useNavigate();
//   const { isAuthenticated } = useAuth();

//   const [formData, setFormData] = useState({
//     fullName: '',
//     mobile: '',
//     email: '',
//     area: '',
//     timeSlot: '',
//     address: '',
//     notes: ''
//   });

//   const [plan, setPlan] = useState('weekly');
//   const [combo, setCombo] = useState('2item');
//   const [errors, setErrors] = useState({}); 
//   const [isProcessing, setIsProcessing] = useState(false); 

//   // --- 2. PRICING LOGIC ---
//   const PRICING = {
//     '2item': { daily: 220, label: '₹220/meal', value: 280 },
//     '3item': { daily: 320, label: '₹320/meal', value: 430 }
//   };

//   // UPDATED: Trial is now 3 Days
//   const DURATION = {
//     'trial': { days: 3, label: '3 Days' }, 
//     'weekly': { days: 6, label: '6 Days' },
//     'monthly': { days: 26, label: '26 Days' }
//   };

//   const getCost = () => PRICING[combo].daily * DURATION[plan].days;
  
//   const getSavings = () => {
//     const actualCost = PRICING[combo].value * DURATION[plan].days;
//     return actualCost - getCost();
//   };

//   // --- 3. INPUT HANDLING ---
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     if (errors[name]) setErrors({ ...errors, [name]: null });
//   };

//   // --- 4. VALIDATION LOGIC ---
//   const validateForm = () => {
//     let newErrors = {};
//     let isValid = true;

//     if (!formData.fullName.trim()) { newErrors.fullName = 'Required'; isValid = false; }
    
//     const mobileRegex = /^[6-9]\d{9}$/;
//     if (!formData.mobile || !mobileRegex.test(formData.mobile)) { newErrors.mobile = 'Invalid Mobile'; isValid = false; }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (formData.email && !emailRegex.test(formData.email)) { newErrors.email = 'Invalid Email'; isValid = false; }

//     if (!formData.area) { newErrors.area = 'Select Area'; isValid = false; }
//     if (!formData.timeSlot) { newErrors.timeSlot = 'Select Time'; isValid = false; }
//     if (!formData.address || formData.address.length < 10) { newErrors.address = 'Full Address Required'; isValid = false; }

//     setErrors(newErrors);
//     return isValid;
//   };

//   // --- 5. PAYMENT HANDLER (UPDATED WITH CORRECT SCHEMA MAPPING) ---
//   const handleCheckOut = async (amount) => {
    
//     // --- TEST MODE: COMMENT THIS LINE BELOW TO GO LIVE ---
//     amount = 1; // Forces payment to ₹1 regardless of plan selected
//     // ----------------------------------------------------

//     // if (!isAuthenticated) {
//     //    toast.error("Please login to subscribe");
//     //    navigate('/AuthPage');
//     //    return;
//     // }

//     setIsProcessing(true);

//     try {
//       // 1. Get Key
//       const { data: { key } } = await axios.get(`${ApiPath}jaavapotpayment/api/getkey`);
      
//       // 2. Create Order
//       const { data: { order } } = await axios.post(`${ApiPath}jaavapotpayment/checkout`, { amount });

//       // 3. Razorpay Options
//       const options = {
//         key,
//         amount: order.amount,
//         currency: "INR",
//         name: "Jaavapot",
//         description: `${plan} Subscription - ${combo}`,
//         order_id: order.id,
//         handler: async function (response) {
//           try {
//             let userEmail = localStorage.getItem("userEmail") || formData.email;

//             // =========================================================
//             // DATA TRANSFORMATION FOR BACKEND SCHEMA
//             // =========================================================
            
//             // 1. Calculate Dates
//             const startDate = new Date();
//             const endDate = new Date(startDate);
//             endDate.setDate(startDate.getDate() + DURATION[plan].days);

//             // 2. Map Frontend values to Backend Enums
//             const AREA_MAP = {
//               'madhapur': 'Madhapur',
//               'hitech': 'Hitech City',
//               'gachibowli': 'Gachibowli',
//               'kondapur': 'Kondapur'
//             };

//             const TIME_MAP = {
//               '700': '07:00-07:30',
//               '730': '07:30-08:00'
//             };

//             const PLAN_MAP = {
//               'trial': 'TRIAL',
//               'weekly': 'WEEKLY',
//               'monthly': 'MONTHLY'
//             };

//             const COMBO_MAP = {
//               '2item': '2_ITEM_COMBO',
//               '3item': '3_ITEM_COMBO'
//             };

//             // 3. Construct the Nested Payload
//             const finalSubscriptionData = {
//               user: {
//                 fullName: formData.fullName,
//                 mobile: formData.mobile,
//                 email: userEmail
//               },
//               delivery: {
//                 area: AREA_MAP[formData.area], // Converts 'madhapur' -> 'Madhapur'
//                 address: formData.address,
//                 preferredTimeSlot: TIME_MAP[formData.timeSlot] // Converts '700' -> '07:00-07:30'
//               },
//               planDetails: {
//                 comboType: COMBO_MAP[combo], // Converts '2item' -> '2_ITEM_COMBO'
//                 planDuration: PLAN_MAP[plan], // Converts 'weekly' -> 'WEEKLY'
//                 startDate: startDate,
//                 endDate: endDate,
//                 daysRemaining: DURATION[plan].days
//               },
//               payment: {
//                 amount: amount, // The amount paid (e.g., 1 or real price)
//                 status: 'SUCCESS',
//                 transactionId: response.razorpay_payment_id
//               },
//               status: 'ACTIVE',
//               additionalNotes: formData.notes || ""
//             };

//             // console.log("Sending Payload:", finalSubscriptionData); // Debug if needed

//             // --- 4. CALL THE NEW AZURE API ---
//             const apiResponse = await axios.post(
//               'https://pagoanalytics.azurewebsites.net/jaavapotsubscription/subscriptions', 
//               finalSubscriptionData
//             );

//             if (apiResponse.status === 200 || apiResponse.status === 201) {
//               toast.success("Subscription Confirmed! We will start your deliveries.");
              
//               // Optional: Send Email Notification
//               try {
//                 await axios.post(`${ApiPath}jaavapotemailnotification/send-email`, {
//                   emailid: "orders@thejaavapot.com",
//                   subscription_data: finalSubscriptionData,
//                 });
//               } catch (err) {
//                 console.warn("Email notification failed, but subscription saved.");
//               }

//               // Reset Form
//               setFormData({ fullName: '', mobile: '', email: '', area: '', timeSlot: '', address: '', notes: '' });
//               setPlan('weekly');
//               navigate("/subscriptions");
//             }

//           } catch (error) {
//             console.error("Error saving subscription:", error);
//             // Show detailed error if available from backend
//             const msg = error.response?.data?.error || error.message;
//             toast.error(`Failed to save: ${msg}`);
//           } finally {
//             setIsProcessing(false);
//           }
//         },
//         prefill: {
//           name: formData.fullName,
//           email: formData.email,
//           contact: formData.mobile,
//         },
//         theme: { color: "#FD7E4B" },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
      
//     } catch (error) {
//       console.error("Checkout Error:", error);
//       toast.error("Failed to initiate payment.");
//       setIsProcessing(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       handleCheckOut(getCost());
//     } else {
//       toast.error("Please fill all required fields correctly");
//     }
//   };

//   return (
//     <section className="py-5" style={{ backgroundColor: colors.creamBg }} id="subscribe">
//       <Container>
//         <div className="text-center mb-4">
//           <h6 className="text-uppercase fw-bold small mb-1" style={{ color: colors.primaryOrange }}>Join the Club</h6>
//           <h3 className="fw-bold text-dark">Setup Your Subscription</h3>
//         </div>

//         <Row className="g-4">
//           {/* --- LEFT COLUMN: FORM --- */}
//           <Col lg={7}>
//             <Card className="border-0 shadow-sm p-3" style={{ borderRadius: '15px' }}>
//               <Form onSubmit={handleSubmit} noValidate>
                
//                 {/* 1. Personal Details */}
//                 <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
//                   <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>1</Badge> Personal Details
//                 </h6>
//                 <Row className="g-2 mb-3">
//                   <Col md={6}>
//                     <InputGroup size="sm" hasValidation>
//                       <InputGroup.Text className="bg-light"><FaUser/></InputGroup.Text>
//                       <Form.Control type="text" placeholder="Full Name *" name="fullName" value={formData.fullName} onChange={handleChange} isInvalid={!!errors.fullName} />
//                       <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
//                     </InputGroup>
//                   </Col>
//                   <Col md={6}>
//                     <InputGroup size="sm" hasValidation>
//                       <InputGroup.Text className="bg-light"><FaPhone/></InputGroup.Text>
//                       <Form.Control type="tel" placeholder="Mobile *" name="mobile" value={formData.mobile} onChange={handleChange} maxLength={10} isInvalid={!!errors.mobile} />
//                       <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
//                     </InputGroup>
//                   </Col>
//                   <Col md={12}>
//                       <InputGroup size="sm" hasValidation>
//                       <InputGroup.Text className="bg-light"><FaEnvelope/></InputGroup.Text>
//                       <Form.Control type="email" placeholder="Email (Optional)" name="email" value={formData.email} onChange={handleChange} isInvalid={!!errors.email} />
//                       <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
//                     </InputGroup>
//                   </Col>
//                 </Row>

//                 {/* 2. Delivery Details */}
//                 <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
//                   <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>2</Badge> Delivery Details
//                 </h6>
//                 <Row className="g-2 mb-3">
//                   <Col md={6}>
//                     <Form.Select size="sm" name="area" value={formData.area} onChange={handleChange} isInvalid={!!errors.area}>
//                       <option value="">Select Area *</option>
//                       <option value="madhapur">Madhapur</option>
//                       <option value="hitech">Hitech City</option>
//                       <option value="gachibowli">Gachibowli</option>
//                     </Form.Select>
//                   </Col>
//                   <Col md={6}>
//                       <Form.Select size="sm" name="timeSlot" value={formData.timeSlot} onChange={handleChange} isInvalid={!!errors.timeSlot}>
//                         <option value="">Time Slot *</option>
//                         <option value="700">07:00 - 07:30 AM</option>
//                         <option value="730">07:30 - 08:00 AM</option>
//                       </Form.Select>
//                   </Col>
//                   <Col md={12}>
//                     <InputGroup size="sm" hasValidation>
//                       <InputGroup.Text className="bg-light"><FaMapMarkerAlt/></InputGroup.Text>
//                       <Form.Control as="textarea" rows={1} placeholder="Full Address *" name="address" value={formData.address} onChange={handleChange} isInvalid={!!errors.address} />
//                     </InputGroup>
//                   </Col>
//                 </Row>

//                 {/* 3. Plan Configuration */}
//                 <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
//                   <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>3</Badge> Select Plan
//                 </h6>
                
//                 <div className="d-flex gap-2 mb-2">
//                   <Button variant={combo === '2item' ? 'warning' : 'outline-light'} className={`flex-fill d-flex align-items-center justify-content-center gap-2 border ${combo !== '2item' ? 'text-muted border-secondary' : 'text-dark fw-bold'}`} onClick={() => setCombo('2item')} size="sm" type="button">
//                     <div className="text-start lh-1">
//                       <div className="small">2-Item Combo</div>
//                       <div style={{fontSize: '0.7rem'}}>₹220/day</div>
//                     </div>
//                   </Button>
//                   <Button variant={combo === '3item' ? 'warning' : 'outline-light'} className={`flex-fill d-flex align-items-center justify-content-center gap-2 border ${combo !== '3item' ? 'text-muted border-secondary' : 'text-dark fw-bold'}`} onClick={() => setCombo('3item')} size="sm" type="button">
//                     <div className="text-start lh-1">
//                       <div className="small">3-Item Combo</div>
//                       <div style={{fontSize: '0.7rem'}}>₹320/day</div>
//                     </div>
//                   </Button>
//                 </div>

//                  <div className="btn-group w-100 mb-3" role="group">
//                     {Object.keys(DURATION).map((p) => (
//                       <React.Fragment key={p}>
//                         <input type="radio" className="btn-check" name="plan" id={p} autoComplete="off" checked={plan === p} onChange={() => setPlan(p)} />
//                         <label className="btn btn-sm" style={{ backgroundColor: plan === p ? colors.primaryGreen : 'transparent', color: plan === p ? '#fff' : colors.primaryGreen, borderColor: colors.primaryGreen, border: `1px solid ${colors.primaryGreen}` }} htmlFor={p}>
//                           {p.charAt(0).toUpperCase() + p.slice(1)}
//                         </label>
//                       </React.Fragment>
//                     ))}
//                   </div>

//                 <InputGroup size="sm">
//                   <InputGroup.Text className="bg-light"><MdOutlineStickyNote2/></InputGroup.Text>
//                   <Form.Control as="textarea" rows={1} placeholder="Notes (Optional)" name="notes" value={formData.notes} onChange={handleChange} />
//                 </InputGroup>
//               </Form>
//             </Card>
//           </Col>

//           {/* --- RIGHT COLUMN: SUMMARY --- */}
//           <Col lg={5}>
//             <div style={{ position: 'sticky', top: '20px' }}>
//               <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} key={plan + combo}>
//                 <Card className="border-0 shadow text-center overflow-hidden" style={{ borderRadius: '15px', backgroundColor: '#fff' }}>
//                   <div className="py-2" style={{ backgroundColor: colors.primaryOrange }}>
//                     <h6 className="fw-bold mb-0 text-white small">Order Summary</h6>
//                   </div>
//                   <Card.Body className="p-4">
//                     <div className="d-flex justify-content-between align-items-end mb-3 border-bottom pb-3">
//                       <div className="text-start">
//                         <div className="text-muted small">Plan</div>
//                         <h5 className="fw-bold text-capitalize mb-0">{plan} Subscription</h5>
//                         <small className="text-muted">{DURATION[plan].days} Days x ₹{PRICING[combo].daily}</small>
//                       </div>
//                       <div className="text-end">
//                           <div className="text-muted small">Total</div>
//                           <h3 className="fw-bold mb-0" style={{ color: colors.primaryOrange }}>₹{getCost()}</h3>
//                       </div>
//                     </div>

//                     {plan !== 'trial' && (
//                       <div className="py-2 d-flex align-items-center justify-content-center gap-2 mb-3" style={{ fontSize: '0.85rem', backgroundColor: colors.creamBg, color: colors.primaryGreen, border: `2px solid ${colors.primaryGreen}`, borderRadius: '8px' }}>
//                         <MdSavings size={18}/>
//                         <span>You save <strong>₹{getSavings()}</strong> on this plan!</span>
//                       </div>
//                     )}

//                     <ul className="list-unstyled text-start small mb-4 bg-light p-3 rounded">
//                       <li className="d-flex justify-content-between mb-2"><span>Daily Meal Cost:</span><span className="fw-bold">₹{PRICING[combo].daily}</span></li>
//                       <li className="d-flex justify-content-between mb-2"><span>Delivery Charges:</span><span className="fw-bold text-success">FREE</span></li>
//                       <li className="d-flex justify-content-between"><span>Items:</span><span className="fw-bold">{combo === '2item' ? 'Breakfast + Porridge' : 'Breakfast + Porridge + Soup'}</span></li>
//                     </ul>

//                     <Button size="lg" className="w-100 rounded-pill shadow-sm fw-bold fs-6" style={{ backgroundColor: colors.primaryOrange, borderColor: colors.primaryOrange, color: '#fff' }} onClick={handleSubmit} disabled={isProcessing}>
//                       {isProcessing ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>Processing Payment...</> : `Pay ₹${getCost()} & Subscribe`}
//                     </Button>

//                     <small className="text-muted d-block mt-3" style={{ fontSize: '0.7rem' }}>By clicking subscribe, you agree to our T&C.</small>
//                   </Card.Body>
//                 </Card>
//               </motion.div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default SubscriptionForm;

import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, InputGroup, Badge, Spinner } from 'react-bootstrap';
import { FaUser, FaPhone, FaMapMarkerAlt, FaEnvelope, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import { MdOutlineStickyNote2, MdSavings } from 'react-icons/md';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../store/AuthContext';
import { ApiPath } from '../../../../config';

// --- SUB-COMPONENT: SUCCESS MESSAGE ---
const SuccessView = ({ data, onNavigate, colors }) => {
  return (
    <Container className="py-5" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }} 
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-100"
        style={{ maxWidth: '500px' }}
      >
        <Card className="border-0 shadow-lg text-center p-4" style={{ borderRadius: '20px' }}>
          <Card.Body>
            <motion.div 
              initial={{ scale: 0 }} 
              animate={{ scale: 1 }} 
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="mb-4"
            >
              <FaCheckCircle size={80} color={colors.primaryGreen} />
            </motion.div>
            
            <h2 className="fw-bold mb-2" style={{ color: colors.primaryGreen }}>Payment Successful!</h2>
            <p className="text-muted mb-4">Welcome to the Jaavapot Family.</p>

            <div className="bg-light p-3 rounded text-start mb-4 small">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Transaction ID:</span>
                <span className="fw-bold text-dark">{data.payment.transactionId}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Amount Paid:</span>
                <span className="fw-bold text-dark">₹{data.payment.amount}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Plan:</span>
                <span className="fw-bold text-capitalize">{data.planDetails.planDuration.toLowerCase()}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-muted">Start Date:</span>
                <span className="fw-bold">{new Date(data.planDetails.startDate).toLocaleDateString()}</span>
              </div>
            </div>

            <Button 
              size="lg" 
              className="w-100 rounded-pill fw-bold"
              style={{ backgroundColor: colors.primaryOrange, borderColor: colors.primaryOrange }}
              onClick={onNavigate}
            >
              Go to My Subscriptions <FaArrowRight className="ms-2"/>
            </Button>
          </Card.Body>
        </Card>
      </motion.div>
    </Container>
  );
};


const SubscriptionForm = () => {
  // TJP Brand Colors
  const colors = {
    primaryOrange: '#FD7E4B',
    primaryGreen: '#2e7d32',
    creamBg: '#FDF0DD',
    lightCream: '#FFFBF2'
  };

  // --- 1. STATE MANAGEMENT ---
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    email: '',
    area: '',
    timeSlot: '',
    address: '',
    notes: ''
  });

  const [plan, setPlan] = useState('weekly');
  const [combo, setCombo] = useState('2item');
  const [errors, setErrors] = useState({}); 
  const [isProcessing, setIsProcessing] = useState(false);
  
  // NEW: State to hold success data to trigger the SuccessView
  const [successData, setSuccessData] = useState(null); 

  // --- 2. PRICING LOGIC ---
  const PRICING = {
    '2item': { daily: 220, label: '₹220/meal', value: 280 },
    '3item': { daily: 320, label: '₹320/meal', value: 430 }
  };

  const DURATION = {
    'trial': { days: 3, label: '3 Days' }, 
    'weekly': { days: 6, label: '6 Days' },
    'monthly': { days: 26, label: '26 Days' }
  };

  const getCost = () => PRICING[combo].daily * DURATION[plan].days;
  
  const getSavings = () => {
    const actualCost = PRICING[combo].value * DURATION[plan].days;
    return actualCost - getCost();
  };

  // --- 3. INPUT HANDLING ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: null });
  };

  // --- 4. VALIDATION LOGIC ---
  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!formData.fullName.trim()) { newErrors.fullName = 'Required'; isValid = false; }
    
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!formData.mobile || !mobileRegex.test(formData.mobile)) { newErrors.mobile = 'Invalid Mobile'; isValid = false; }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) { newErrors.email = 'Invalid Email'; isValid = false; }

    if (!formData.area) { newErrors.area = 'Select Area'; isValid = false; }
    if (!formData.timeSlot) { newErrors.timeSlot = 'Select Time'; isValid = false; }
    if (!formData.address || formData.address.length < 10) { newErrors.address = 'Full Address Required'; isValid = false; }

    setErrors(newErrors);
    return isValid;
  };

  // --- 5. PAYMENT HANDLER ---
  const handleCheckOut = async (amount) => {
    
    // --- TEST MODE: COMMENT THIS LINE BELOW TO GO LIVE ---
    // amount = 1; 
    // ----------------------------------------------------

    // if (!isAuthenticated) {
    //    toast.error("Please login to subscribe");
    //    navigate('/AuthPage');
    //    return;
    // }

    setIsProcessing(true);

    try {
      const { data: { key } } = await axios.get(`${ApiPath}jaavapotpayment/api/getkey`);
      const { data: { order } } = await axios.post(`${ApiPath}jaavapotpayment/checkout`, { amount });

      const options = {
        key,
        amount: order.amount,
        currency: "INR",
        name: "Jaavapot",
        description: `${plan} Subscription - ${combo}`,
        order_id: order.id,
        handler: async function (response) {
          try {
            let userEmail = localStorage.getItem("userEmail") || formData.email;

            // Mapping & Payload Construction
            const startDate = new Date();
            const endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + DURATION[plan].days);

            const AREA_MAP = {
              'madhapur': 'Madhapur',
              'hitech': 'Hitech City',
              'gachibowli': 'Gachibowli',
              'kondapur': 'Kondapur'
            };
            const TIME_MAP = { '700': '07:00-07:30', '730': '07:30-08:00' };
            const PLAN_MAP = { 'trial': 'TRIAL', 'weekly': 'WEEKLY', 'monthly': 'MONTHLY' };
            const COMBO_MAP = { '2item': '2_ITEM_COMBO', '3item': '3_ITEM_COMBO' };

            const finalSubscriptionData = {
              user: {
                fullName: formData.fullName,
                mobile: formData.mobile,
                email: userEmail
              },
              delivery: {
                area: AREA_MAP[formData.area],
                address: formData.address,
                preferredTimeSlot: TIME_MAP[formData.timeSlot]
              },
              planDetails: {
                comboType: COMBO_MAP[combo],
                planDuration: PLAN_MAP[plan],
                startDate: startDate,
                endDate: endDate,
                daysRemaining: DURATION[plan].days
              },
              payment: {
                amount: amount,
                status: 'SUCCESS',
                transactionId: response.razorpay_payment_id
              },
              status: 'ACTIVE',
              additionalNotes: formData.notes || ""
            };

            const apiResponse = await axios.post(
              'https://pagoanalytics.azurewebsites.net/jaavapotsubscription/subscriptions', 
              finalSubscriptionData
            );

            if (apiResponse.status === 200 || apiResponse.status === 201) {
              // --- SUCCESS: SEND EMAIL & SHOW SUCCESS VIEW ---
              
              // 1. Send Email (Background)
              try {
                await axios.post(`${ApiPath}jaavapotemailnotification/send-email`, {
                  emailid: "orders@thejaavapot.com",
                  subscription_data: finalSubscriptionData,
                });
              } catch (err) {
                console.warn("Email notification failed");
              }

              // 2. Clear Form Data
              setFormData({ fullName: '', mobile: '', email: '', area: '', timeSlot: '', address: '', notes: '' });
              
              // 3. TRIGGER SUCCESS COMPONENT (Instead of navigating immediately)
              setSuccessData(finalSubscriptionData); 
              window.scrollTo(0, 0);
            }

          } catch (error) {
            console.error("Error saving subscription:", error);
            const msg = error.response?.data?.error || error.message;
            toast.error(`Failed to save: ${msg}`);
          } finally {
            setIsProcessing(false);
          }
        },
        prefill: {
          name: formData.fullName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#FD7E4B" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      
    } catch (error) {
      console.error("Checkout Error:", error);
      toast.error("Failed to initiate payment.");
      setIsProcessing(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleCheckOut(getCost());
    } else {
      toast.error("Please fill all required fields correctly");
    }
  };

  // --- RENDER LOGIC ---
  // If payment success, show SuccessView instead of Form
  if (successData) {
    return (
      <section className="py-5" style={{ backgroundColor: colors.creamBg }}>
        <SuccessView 
          data={successData} 
          colors={colors} 
          onNavigate={() => navigate("/subscriptions")} 
        />
      </section>
    );
  }

  return (
    <section className="py-5" style={{ backgroundColor: colors.creamBg }} id="subscribe">
      <Container>
        <div className="text-center mb-4">
          <h6 className="text-uppercase fw-bold small mb-1" style={{ color: colors.primaryOrange }}>Join the Club</h6>
          <h3 className="fw-bold text-dark">Setup Your Subscription</h3>
        </div>

        <Row className="g-4">
          {/* --- LEFT COLUMN: FORM --- */}
          <Col lg={7}>
            <Card className="border-0 shadow-sm p-3" style={{ borderRadius: '15px' }}>
              <Form onSubmit={handleSubmit} noValidate>
                
                {/* 1. Personal Details */}
                <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
                  <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>1</Badge> Personal Details
                </h6>
                <Row className="g-2 mb-3">
                  <Col md={6}>
                    <InputGroup size="sm" hasValidation>
                      <InputGroup.Text className="bg-light"><FaUser/></InputGroup.Text>
                      <Form.Control type="text" placeholder="Full Name *" name="fullName" value={formData.fullName} onChange={handleChange} isInvalid={!!errors.fullName} />
                      <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                    </InputGroup>
                  </Col>
                  <Col md={6}>
                    <InputGroup size="sm" hasValidation>
                      <InputGroup.Text className="bg-light"><FaPhone/></InputGroup.Text>
                      <Form.Control type="tel" placeholder="Mobile *" name="mobile" value={formData.mobile} onChange={handleChange} maxLength={10} isInvalid={!!errors.mobile} />
                      <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
                    </InputGroup>
                  </Col>
                  <Col md={12}>
                      <InputGroup size="sm" hasValidation>
                      <InputGroup.Text className="bg-light"><FaEnvelope/></InputGroup.Text>
                      <Form.Control type="email" placeholder="Email (Optional)" name="email" value={formData.email} onChange={handleChange} isInvalid={!!errors.email} />
                      <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </InputGroup>
                  </Col>
                </Row>

                {/* 2. Delivery Details */}
                <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
                  <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>2</Badge> Delivery Details
                </h6>
                <Row className="g-2 mb-3">
                  <Col md={6}>
                    <Form.Select size="sm" name="area" value={formData.area} onChange={handleChange} isInvalid={!!errors.area}>
                      <option value="">Select Area *</option>
                      <option value="madhapur">Madhapur</option>
                      <option value="hitech">Hitech City</option>
                      <option value="gachibowli">Gachibowli</option>
                    </Form.Select>
                  </Col>
                  <Col md={6}>
                      <Form.Select size="sm" name="timeSlot" value={formData.timeSlot} onChange={handleChange} isInvalid={!!errors.timeSlot}>
                        <option value="">Time Slot *</option>
                        <option value="700">07:00 - 07:30 AM</option>
                        <option value="730">07:30 - 08:00 AM</option>
                      </Form.Select>
                  </Col>
                  <Col md={12}>
                    <InputGroup size="sm" hasValidation>
                      <InputGroup.Text className="bg-light"><FaMapMarkerAlt/></InputGroup.Text>
                      <Form.Control as="textarea" rows={1} placeholder="Full Address *" name="address" value={formData.address} onChange={handleChange} isInvalid={!!errors.address} />
                    </InputGroup>
                  </Col>
                </Row>

                {/* 3. Plan Configuration */}
                <h6 className="fw-bold mb-2 small d-flex align-items-center" style={{ color: colors.primaryGreen }}>
                  <Badge className="me-2 rounded-circle p-1" style={{ backgroundColor: colors.primaryGreen }}>3</Badge> Select Plan
                </h6>
                
                <div className="d-flex gap-2 mb-2">
                  <Button variant={combo === '2item' ? 'warning' : 'outline-light'} className={`flex-fill d-flex align-items-center justify-content-center gap-2 border ${combo !== '2item' ? 'text-muted border-secondary' : 'text-dark fw-bold'}`} onClick={() => setCombo('2item')} size="sm" type="button">
                    <div className="text-start lh-1">
                      <div className="small">2-Item Combo</div>
                      <div style={{fontSize: '0.7rem'}}>₹220/day</div>
                    </div>
                  </Button>
                  <Button variant={combo === '3item' ? 'warning' : 'outline-light'} className={`flex-fill d-flex align-items-center justify-content-center gap-2 border ${combo !== '3item' ? 'text-muted border-secondary' : 'text-dark fw-bold'}`} onClick={() => setCombo('3item')} size="sm" type="button">
                    <div className="text-start lh-1">
                      <div className="small">3-Item Combo</div>
                      <div style={{fontSize: '0.7rem'}}>₹320/day</div>
                    </div>
                  </Button>
                </div>

                 <div className="btn-group w-100 mb-3" role="group">
                    {Object.keys(DURATION).map((p) => (
                      <React.Fragment key={p}>
                        <input type="radio" className="btn-check" name="plan" id={p} autoComplete="off" checked={plan === p} onChange={() => setPlan(p)} />
                        <label className="btn btn-sm" style={{ backgroundColor: plan === p ? colors.primaryGreen : 'transparent', color: plan === p ? '#fff' : colors.primaryGreen, borderColor: colors.primaryGreen, border: `1px solid ${colors.primaryGreen}` }} htmlFor={p}>
                          {p.charAt(0).toUpperCase() + p.slice(1)}
                        </label>
                      </React.Fragment>
                    ))}
                  </div>

                <InputGroup size="sm">
                  <InputGroup.Text className="bg-light"><MdOutlineStickyNote2/></InputGroup.Text>
                  <Form.Control as="textarea" rows={1} placeholder="Notes (Optional)" name="notes" value={formData.notes} onChange={handleChange} />
                </InputGroup>
              </Form>
            </Card>
          </Col>

          {/* --- RIGHT COLUMN: SUMMARY --- */}
          <Col lg={5}>
            <div style={{ position: 'sticky', top: '20px' }}>
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} key={plan + combo}>
                <Card className="border-0 shadow text-center overflow-hidden" style={{ borderRadius: '15px', backgroundColor: '#fff' }}>
                  <div className="py-2" style={{ backgroundColor: colors.primaryOrange }}>
                    <h6 className="fw-bold mb-0 text-white small">Order Summary</h6>
                  </div>
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-end mb-3 border-bottom pb-3">
                      <div className="text-start">
                        <div className="text-muted small">Plan</div>
                        <h5 className="fw-bold text-capitalize mb-0">{plan} Subscription</h5>
                        <small className="text-muted">{DURATION[plan].days} Days x ₹{PRICING[combo].daily}</small>
                      </div>
                      <div className="text-end">
                          <div className="text-muted small">Total</div>
                          <h3 className="fw-bold mb-0" style={{ color: colors.primaryOrange }}>₹{getCost()}</h3>
                      </div>
                    </div>

                    {plan !== 'trial' && (
                      <div className="py-2 d-flex align-items-center justify-content-center gap-2 mb-3" style={{ fontSize: '0.85rem', backgroundColor: colors.creamBg, color: colors.primaryGreen, border: `2px solid ${colors.primaryGreen}`, borderRadius: '8px' }}>
                        <MdSavings size={18}/>
                        <span>You save <strong>₹{getSavings()}</strong> on this plan!</span>
                      </div>
                    )}

                    <ul className="list-unstyled text-start small mb-4 bg-light p-3 rounded">
                      <li className="d-flex justify-content-between mb-2"><span>Daily Meal Cost:</span><span className="fw-bold">₹{PRICING[combo].daily}</span></li>
                      <li className="d-flex justify-content-between mb-2"><span>Delivery Charges:</span><span className="fw-bold text-success">FREE</span></li>
                      <li className="d-flex justify-content-between"><span>Items:</span><span className="fw-bold">{combo === '2item' ? 'Breakfast + Porridge' : 'Breakfast + Porridge + Soup'}</span></li>
                    </ul>

                    <Button size="lg" className="w-100 rounded-pill shadow-sm fw-bold fs-6" style={{ backgroundColor: colors.primaryOrange, borderColor: colors.primaryOrange, color: '#fff' }} onClick={handleSubmit} disabled={isProcessing}>
                      {isProcessing ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>Processing Payment...</> : `Pay ₹${getCost()} & Subscribe`}
                    </Button>

                    <small className="text-muted d-block mt-3" style={{ fontSize: '0.7rem' }}>By clicking subscribe, you agree to our T&C.</small>
                  </Card.Body>
                </Card>
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SubscriptionForm;